import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = {
  id?: string;
  enabled?: boolean;
};
export const useFetchAddonMultiPayment = ({id, enabled = true}: Props) => {
  const {getAddonMultiPayment} = useChekinSDK();

  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.addonMultiPayment, id],
    queryFn: () => getAddonMultiPayment(id ?? ''),
    enabled: Boolean(id && enabled),
    refetchOnWindowFocus: false,
  });
};
